import './layout.css';

/**
 * The three-pane frame: rail, main column, optional inspector.
 *
 * Below 1500px the inspector stops being a column and is rendered by the page as
 * a drawer instead — squeezing a 41-row attribute table and a chat thread into a
 * laptop width makes both unreadable.
 */
export function AppShell({ sidebar, children, inspector = null }) {
  return (
    <div className={`shell ${inspector ? 'shell--with-inspector' : ''}`}>
      {sidebar}
      {children}
      {inspector}
    </div>
  );
}
